var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "blocks" }, [
        _c(
          "div",
          { staticClass: "mobile-list" },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center justify-content-between mx-3 px-1"
              },
              [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("span", {
                    staticClass: "mod-icon-arrow-left mod-icon-back",
                    on: {
                      click: function($event) {
                        _vm.$router.back()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("h2", { staticClass: "ml-2" }, [_vm._v("Totals")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-grow-1 mr-3" }, [
                  _c("div", { staticClass: "input-group search w-100 ml-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn input-group-btn",
                        attrs: { type: "button" },
                        on: { click: _vm.clearSearch }
                      },
                      [
                        _c("i", {
                          class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.q,
                          expression: "q"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Search" },
                      domProps: { value: _vm.q },
                      on: {
                        keyup: function($event) {
                          _vm.searchText($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.q = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 border-bottom" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between mx-3 px-1"
                },
                [
                  _c("p", { staticClass: "text-secondary m-0" }, [
                    _vm._v(
                      "Statistics for " + _vm._s(_vm.meta.total) + " users"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex align-items-center mb-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-schedule btn-refine",
                        on: {
                          click: function($event) {
                            _vm.showFilters = true
                          }
                        }
                      },
                      [
                        !_vm.clearFiltersButtonShouldBeDisabled
                          ? _c("span", {
                              staticClass: "mobile-dot-refine-active-filters"
                            })
                          : _vm._e(),
                        _vm._v("\n              REFINE\n            ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary expand-all",
                        on: {
                          click: function($event) {
                            _vm.expanded = !_vm.expanded
                          }
                        }
                      },
                      [
                        _c("i", {
                          class: [
                            _vm.expanded ? "fa fa-compress" : "fa fa-expand"
                          ]
                        })
                      ]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.sales, function(sale) {
              return _c("SalesTotalsBlockMobile", {
                key: sale.id,
                attrs: { sale: sale, expanded: _vm.expanded },
                on: {
                  openSidebar: function($event) {
                    _vm.openSidebar(sale)
                  }
                }
              })
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row blocks" },
              [
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1 pr-0",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "desktop-list" },
          [
            _c(
              "div",
              { staticClass: "row pt-3 l-m-b-20 d-flex align-items-center" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "col-10 d-flex" }, [
                  _c("div", { staticClass: "input-group search" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn input-group-btn",
                        attrs: { type: "button" },
                        on: { click: _vm.clearSearch }
                      },
                      [
                        _c("i", {
                          class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.q,
                          expression: "q"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Search" },
                      domProps: { value: _vm.q },
                      on: {
                        keyup: function($event) {
                          _vm.searchText($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.q = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c("div", { staticClass: "col-12 filters-field" }, [
                _c("span", [_vm._v("Filters:")]),
                _vm._v(" "),
                _vm.filtersLoaded
                  ? _c("span", [
                      _vm.filters.carrier.length
                        ? _c(
                            "span",
                            _vm._l(_vm.filters.carrier, function(carrier) {
                              return _c(
                                "span",
                                {
                                  key: carrier,
                                  staticClass: "filter-item btn btn-filter"
                                },
                                [
                                  _c("span", {
                                    staticClass: "mod-icon-filter",
                                    on: {
                                      click: function($event) {
                                        _vm.removeFilter("carrier", carrier)
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    "\n                Carrier: " +
                                      _vm._s(
                                        _vm.carriers.find(function(el) {
                                          return el.id === carrier
                                        }).name
                                      )
                                  )
                                ]
                              )
                            })
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filters.company.length
                        ? _c(
                            "span",
                            _vm._l(_vm.filters.company, function(company) {
                              return _c(
                                "span",
                                {
                                  key: company,
                                  staticClass: "filter-item btn btn-filter"
                                },
                                [
                                  _c("span", {
                                    staticClass: "mod-icon-filter",
                                    on: {
                                      click: function($event) {
                                        _vm.removeFilter("company", company)
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    "\n                Company: " +
                                      _vm._s(
                                        _vm.companies.find(function(el) {
                                          return el.id === company
                                        }).name
                                      )
                                  )
                                ]
                              )
                            })
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filters.created_at
                        ? _c(
                            "span",
                            { staticClass: "filter-item btn btn-filter" },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("created_at")
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Created at: " +
                                  _vm._s(_vm.filters.created_at)
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filters.tags && _vm.filters.tags.length && _vm.tags
                        ? _c(
                            "span",
                            _vm._l(_vm.filters.tags, function(tag) {
                              return _c(
                                "span",
                                {
                                  key: tag,
                                  staticClass: "filter-item btn btn-filter"
                                },
                                [
                                  _c("span", {
                                    staticClass: "mod-icon-filter",
                                    on: {
                                      click: function($event) {
                                        _vm.removeFilter("tags", tag)
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    "\n                Tag: " +
                                      _vm._s(
                                        _vm.tags.find(function(el) {
                                          return el.id === tag
                                        }).name
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            })
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.filters.deductedMoverWages
                  ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                      _c("span", {
                        staticClass: "mod-icon-filter",
                        on: {
                          click: function($event) {
                            _vm.filters.deductedMoverWages = null
                          }
                        }
                      }),
                      _vm._v("\n            Deducted mover wages\n          ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary add-filters",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.showFilters = true
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-plus filter-icon" })]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.loading
              ? [
                  _c(
                    "vue-content-loading",
                    { attrs: { width: 800, height: 450 } },
                    _vm._l(15, function(x) {
                      return _c("rect", {
                        key: x,
                        attrs: {
                          x: "10",
                          y: 15 * x * 1.4,
                          rx: "5",
                          ry: "5",
                          width: "720",
                          height: "6"
                        }
                      })
                    })
                  )
                ]
              : !_vm.sales.length
                ? [_c("span", [_vm._v("There are no results.")])]
                : [
                    _c(
                      "div",
                      { staticClass: "sales-table" },
                      [
                        _c("SalesTotalsStatistics", {
                          staticClass: "blocks",
                          attrs: {
                            meta: _vm.meta,
                            sums: _vm.sums,
                            averages: _vm.averages
                          }
                        }),
                        _vm._v(" "),
                        _c("SalesTableHeader", {
                          attrs: {
                            "sort-key": _vm.filters.sortKey,
                            "sort-order": _vm.filters.sortOrder
                          },
                          on: { "sort-by": _vm.sortBy }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "sales-wrapper blocks" },
                          _vm._l(_vm.sales, function(sale) {
                            return _c("SalesTotalsBlock", {
                              key: sale.id,
                              staticClass: "pointer",
                              attrs: { sale: sale }
                            })
                          })
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row blocks" },
                      [
                        _vm.meta.total
                          ? _c(
                              "div",
                              {
                                staticClass: "col-sm-6 mb-1 text-black-50 pl-0"
                              },
                              [
                                _vm._v(
                                  "\n            Showing " +
                                    _vm._s(_vm.meta.from) +
                                    " - " +
                                    _vm._s(_vm.meta.to) +
                                    " of " +
                                    _vm._s(_vm.meta.total) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination", {
                          staticClass: "col-sm-6 mb-1 pr-0",
                          attrs: {
                            "change-page": _vm.changePage,
                            meta: _vm.meta
                          }
                        })
                      ],
                      1
                    )
                  ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-fade" } },
        [
          _c("filters-modal", {
            attrs: {
              "clear-filters-button-should-be-disabled":
                _vm.clearFiltersButtonShouldBeDisabled,
              carriers: _vm.carriers,
              companies: _vm.companies,
              filters: _vm.filters,
              "show-filters": _vm.showFilters,
              tags: _vm.tags
            },
            on: {
              "clear-filters": _vm.clearFilters,
              filter: _vm.filter,
              "hide-filters": _vm.hideFilters,
              search: _vm.search
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-1" }, [_c("h1", [_vm._v("Totals")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-399d4a0b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399d4a0b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/SalesTotals.vue
// module id = null
// module chunks = 